import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import TrialOpenQuestion from '../trial/TrialOpenQuestion';
import { submissionShape, surveyShape } from '../../types';

export default class OpenQuestionsDialog extends Component {
  static renderOpenQuestions = (surveyPayload, submissionPayload) => {
    const { openQuestions } = surveyPayload;
    const { openQuestionAnswers } = submissionPayload;
    if (!openQuestions || !openQuestionAnswers) {
      return false;
    }
    return openQuestions.map((question) => (
      <TrialOpenQuestion
        key={question.question.uuid}
        question={question}
        answers={openQuestionAnswers[question.question.uuid]}
        onChange={() => undefined}
      />
    ));
  };

  static renderContextQuestions = (sectionSurvey, sectionSubmission) => {
    const { contextQuestions } = sectionSurvey;
    if (!contextQuestions) {
      return false;
    }
    return contextQuestions.map((question) => (
      <TrialOpenQuestion
        key={question.question.uuid}
        question={question}
        answers={
          sectionSubmission
          && sectionSubmission.context
          && sectionSubmission.context[question.question.uuid]
        }
        onChange={() => undefined}
      />
    ));
  };

  render() {
    const {
      submission, currentSectionIdx, survey, isOpen, onClose,
    } = this.props;
    const submissionPayload = submission.payload;
    return (
      <GenericDialog
        isOpen={isOpen}
        onClose={onClose}
        closeButtonLabel={<FormattedMessage id="genericClose" />}
      >
        <ContentBox
          title={<FormattedMessage id="review.openQuestionsHeadline" />}
        >
          <div>
            {
              survey.payload.sections.length > 1 && (
                <h1>
                  <FormattedMessage
                    id="review.contextOpenQuestionsSubheadline"
                    values={{
                      name: survey.payload.sections[currentSectionIdx].headline || `${currentSectionIdx}`,
                    }}
                  />
                </h1>
              )
            }
            {
              OpenQuestionsDialog.renderContextQuestions(
                survey.payload.sections[currentSectionIdx],
                submissionPayload.sections[currentSectionIdx],
              )
            }
            <div>
              {
                survey.payload.openQuestions && (
                  <h1><FormattedMessage id="review.trialOpenQuestionsSubheadline" /></h1>
                )
              }
              {
                OpenQuestionsDialog.renderOpenQuestions(
                  survey.payload,
                  submissionPayload,
                )
              }
            </div>
          </div>
        </ContentBox>
      </GenericDialog>
    );
  }
}

OpenQuestionsDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  submission: submissionShape.isRequired,
  currentSectionIdx: PropTypes.number.isRequired,
  survey: surveyShape.isRequired,
};
